/* One scroll-direction owner for desktop and mobile; product headers remain in page flow. */
(() => {
  'use strict';
  if (window.GrowplayHeaderScroll) return;
  let anchor = Math.max(0, window.scrollY);
  let scrollingDown = anchor > 0;
  let frame = 0;
  let observers = [];
  let headers = [];
  const update = () => {
    frame = 0;
    const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - innerHeight));
    const delta = y - anchor;
    if (Math.abs(delta) >= 6) { scrollingDown = delta > 0; anchor = y; }
    if (y <= 0) { scrollingDown = false; anchor = 0; }
    headers.forEach(header => {
      const wrapper = header.closest('.header-sticky-wrapper');
      if (!wrapper) { header.inert = false; return; }
      const active = document.activeElement;
      const focused = header.contains(active) && (active.matches('input, select, textarea') || active.matches(':focus-visible'));
      const menuOpen = document.body.classList.contains('mobile-menu--opened') || header.querySelector('.is-opened, .sticky-menu-wrapper.is-visible');
      const hidden = wrapper.classList.contains('is-sticky') && header.getBoundingClientRect().width > 0 && y > header.offsetHeight && scrollingDown && !focused && !menuOpen;
      if (wrapper.classList.contains('sticky--scroll-up-only-hidden') !== hidden) {
        wrapper.classList.toggle('sticky--scroll-up-only-hidden', hidden);
        window.dispatchEvent(new Event('gp:header-visibility'));
      }
      if (header.inert !== hidden) header.inert = hidden;
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const init = () => {
    observers.forEach(observer => observer.disconnect());
    observers = [];
    headers = ['header', 'mobile-header'].map(id => document.getElementById(id)).filter(Boolean);
    const sections = new Set(headers.map(header => header.closest('.shopify-section')).filter(Boolean));
    sections.forEach(section => {
      const observer = new MutationObserver(schedule);
      observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      observers.push(observer);
    });
    const resize = new ResizeObserver(() => {
      // Header/logo and compact-signup resizing can move the scroll anchor without user scrolling.
      anchor = Math.max(0, window.scrollY);
      schedule();
    });
    headers.forEach(header => resize.observe(header));
    document.querySelectorAll('.growplay-email-signup-section').forEach(section => resize.observe(section));
    observers.push(resize);
    schedule();
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('transitionend', event => {
    if (headers.includes(event.target)) window.dispatchEvent(new Event('gp:header-visibility'));
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  window.addEventListener('pageshow', init);
  window.addEventListener('pagehide', () => { observers.forEach(observer => observer.disconnect()); cancelAnimationFrame(frame); frame = 0; });
  window.GrowplayHeaderScroll = { refresh: schedule };
  init();
})();
